import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Component"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.4697 1.46967C11.7626 1.17678 12.2374 1.17678 12.5303 1.46967L16.0303 4.96967C16.3232 5.26256 16.3232 5.73744 16.0303 6.03033L12.5303 9.53033C12.2374 9.82322 11.7626 9.82322 11.4697 9.53033L7.96967 6.03033C7.67678 5.73744 7.67678 5.26256 7.96967 4.96967L11.4697 1.46967ZM9.56066 5.5L12 7.93934L14.4393 5.5L12 3.06066L9.56066 5.5Z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.9697 8.46967C18.2626 8.17678 18.7374 8.17678 19.0303 8.46967L22.5303 11.9697C22.8232 12.2626 22.8232 12.7374 22.5303 13.0303L19.0303 16.5303C18.7374 16.8232 18.2626 16.8232 17.9697 16.5303L14.4697 13.0303C14.1768 12.7374 14.1768 12.2626 14.4697 11.9697L17.9697 8.46967ZM16.0607 12.5L18.5 14.9393L20.9393 12.5L18.5 10.0607L16.0607 12.5Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.4697 14.4697C11.7626 14.1768 12.2374 14.1768 12.5303 14.4697L16.0303 17.9697C16.3232 18.2626 16.3232 18.7374 16.0303 19.0303L12.5303 22.5303C12.2374 22.8232 11.7626 22.8232 11.4697 22.5303L7.96967 19.0303C7.67678 18.7374 7.67678 18.2626 7.96967 17.9697L11.4697 14.4697ZM9.56066 18.5L12 20.9393L14.4393 18.5L12 16.0607L9.56066 18.5Z"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.96967 7.96967C5.26256 7.67678 5.73744 7.67678 6.03033 7.96967L9.53033 11.4697C9.82322 11.7626 9.82322 12.2374 9.53033 12.5303L6.03033 16.0303C5.73744 16.3232 5.26256 16.3232 4.96967 16.0303L1.46967 12.5303C1.17678 12.2374 1.17678 11.7626 1.46967 11.4697L4.96967 7.96967ZM3.06066 12L5.5 14.4393L7.93934 12L5.5 9.56066L3.06066 12Z"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Component.vue"]]);
